module.exports = __webpack_public_path__ + "img/video_preview.63a3b2d9.png";